import Vue from "vue";

export const toastLaravelErrors = {
  methods: {
    toastLaravelErrors(error) {
      if (error.response?.status === 422) {
        Object.values(error.response.data.data.errors).forEach(error => {
          error.forEach(inner => Vue.$toast.error(inner));
        });
      }
    }
  }
};
